'use strict';

import React from 'react';
const PropTypes = require('prop-types');
import copy from '../../constants/contactDealerCopy.json';
import SanitizeHtml from '../../../global/components/SanitizeHtml';

function ContactDealerMessageSent({ isRemoveContactDealerCTATestRunning }) {
    return (
        <div className="pdp-dealer-section pdp-contact-dealer pdp-contact-dealer-message-sent">
            <h1 className="pdp-contact-dealer-title">{copy.messageSentTitle}</h1>
            {!isRemoveContactDealerCTATestRunning && (
                <p className="pdp-contact-description">
                    <SanitizeHtml content={copy.messageSentBody} />
                </p>
            )}
        </div>
    );
}

ContactDealerMessageSent.propTypes = {
    isRemoveContactDealerCTATestRunning: PropTypes.bool,
};

export default ContactDealerMessageSent;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/ContactDealer/ContactDealerMessageSent.jsx